import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34c19ca1")

_pushScopeId("data-v-34c19ca1")
const _hoisted_1 = { class: "relative edit-body overflow-y-auto pt-1" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "text-12px text-gray-lp-500 mb-6 mr-1" }, " Pilih rentang waktu No. STT Elexys yang gagal melakukan booking. ", -1)
const _hoisted_3 = { class: "flex flex-row justify-end pt-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: true,
    persistent: true,
    title: "Download Data",
    class: "modal-download-failed",
    "onUpdate:modelValue": _ctx.onClose
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_data_wrapper, { label: "Rentang waktu" }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateRangeOptions, (option, index) => {
              return (_openBlock(), _createBlock("div", {
                key: option.value,
                class: ["p-field-radiobutton gap-x-3 flex flex-row relative", `${index == 0 ? 'mt-4' : 'mt-3'}`]
              }, [
                _createVNode(_component_RadioButton, {
                  id: option.value,
                  name: option.name,
                  value: option.value,
                  modelValue: _ctx.dateRadioValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRadioValue = $event))
                }, null, 8, ["id", "name", "value", "modelValue"]),
                _createVNode("label", {
                  for: option.value,
                  class: "cursor-pointer"
                }, _toDisplayString(option.name), 9, ["for"])
              ], 2))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_button_fill, {
            onClick: _ctx.onDownload,
            title: "Download",
            class: "bg-red-lp-300",
            style: {"width":"135px"}
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onUpdate:modelValue"]))
})